import { Link } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { GUARDIANS_COMIC_URL } from "@/constants/guardiansGameRules"

export default function HelpPage() {
  return (
    <GameScreenLayout title="Помощь" backTo="/play">
      <div className="space-y-4 text-sm text-guardians-muted">
        <p>
          <Link to="/welcome" className="text-guardians-accent underline decoration-guardians-accent/40">
            Кратко о игре
          </Link>{" "}
          — слайды перед входом.
        </p>
        <p>
          Веб-клиент «Хранители» (gDaksbyWeb) работает с тем же backend, что и
          мобильное приложение. Для боёв и чата нужен стабильный интернет; для
          сканов и POI — разрешение геолокации в браузере.
        </p>
        <p>
          Поддержка:{" "}
          <a href="mailto:support@daks.by" className="text-guardians-accent">
            support@daks.by
          </a>
        </p>
        <p>
          Комикс и материалы:{" "}
          <a
            href={GUARDIANS_COMIC_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-guardians-accent"
          >
            guardians.daks.by
          </a>
        </p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Радар и дуэль — вкладка «Бой» на главной</li>
          <li>Колодный бой — соберите 6 карт и очередь deck-radar</li>
          <li>Карта — точки сканирования, боссы, почта, банк</li>
          <li>QR-карты — раздел Redeem в колоде</li>
        </ul>
      </div>
    </GameScreenLayout>
  )
}
